<template src="./detail.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import { format } from 'date-fns'

export default {
  name: "aggregatorDetail",
  data() {
    return {
      fileUrl: `${process.env.VUE_APP_API_URL}/file`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('srAccessToken')}`,
        'Access-Control-Allow-Origin': '*',
      },
      ko : ko,
      amount: null,
      aggregatorOption : [],
      aggregator : null,
      
      saleDate : null,
      taxDate : null,
      depositDate : null,
      item : null,
      memo : null,
      
    }
  },
    mounted(){
      this.$nextTick(function(){
        this.callData();
        this.callAggregator();
      })
    },
  computed: {
    
  },
  watch:{
      
  },
  methods: {
    callData(){
      let payload ={
       id : this.$route.params.id
      }
      this.$store.dispatch('DETAIL_SETTLEMENT', payload).then(result =>{
          this.loadingHide()
          let t = result
          // aggregator_id: 12
          // amount: 22222
          // created_at: "2021-08-19T07:21:36.491Z"
          // deposit_date: "2021-08-18"
          // id: 2
          // item: null
          // month: "2021-05"
          // note: null
          // settlement_amount: 222222222
          // tax_invoice_date: "2021-08-10"
          // updated_at: "2021-08-19T07:21:36.491Z"
          // vat: 2222
          // this.amount= this.numberFormat(t.amount)
          this.amount= this.numberFormat(t.amount)
          this.aggregator =t.aggregator_id
          
          this.saleDate =t.month
          this.taxDate =t.tax_invoice_date
          this.depositDate =t.deposit_date
          this.item =t.item
          this.memo =t.memo
      }).catch(error=>{
        const status = error.response.status
        this.loadingHide()
        switch(status){
            
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
                this.alert({msg : error.response.data.message})
            break;
        }
      })
    },
    allSave(){
      let payload ={
        id : Number(this.$route.params.id),
        aggregator_id: this.aggregator,
        month: this.saleDate,
        amount: Number(this.amount.replace(/,/gi, "")),
        tax_invoice_date: this.taxDate,
        deposit_date: this.depositDate,
        item : this.item,
        note : this.note
      }
      if(this.valCheck(this.aggregator)){
        this.alert({msg : '계약사를 선택해주세요.'})
        return false 
      }
      if(this.valCheck(this.amount)){
        this.alert({msg : '정산액을 입력해주세요.'})
        return false 
      }
      if(this.valCheck(this.saleDate)){
        this.alert({msg : '매출월을 입력해주세요.'})
        return false 
      }
     
      this.loadingShow();
      this.$store.dispatch('PUT_SETTLEMENT', payload).then(result =>{
          this.loadingHide()
          this.$router.push('/taxinvoice')
          //페이지 수
      }).catch(error=>{
        const status = error.response.status
        this.loadingHide()
        switch(status){
            
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
                this.alert({msg : error.response.data.message})
            break;
        }
      })
    },
    callAggregator(){
      const option = {
          sort: 'created_at',
          sortorder: 'desc',
          //is_various_artists: false, // 필수 filter
      }
      
      let query = {}

      
      this.loadingShow()

      this.$store.dispatch('GET_AGGREGATOR', option).then(result =>{
          this.loadingHide()
          this.aggregatorOption  = result // 권리자 목록
          
          this.total = result.length // 총인원수 
          
          //페이지 수
      }).catch(error=>{
        const status = error.response.status
        this.loadingHide()
        switch(status){
            
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
                this.alert({msg : error.response.data.message})
            break;
        }
      })
    }
  },
    
}
</script>

<style scoped>

</style>